
interface ThisProps {
  offset: number,
  limit: number,
  totalCount: number,
  pageChange: (e: number) => void,
}

/**
 * @author noone
 */
const PaginatorComponent: React.FC<ThisProps> = (props) => {

  const pageCount = Math.ceil(props.totalCount / props.limit);
  const currentPage = Math.ceil(props.offset / props.limit) + 1;

  const firstpageClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (currentPage === 1) return;
    props.pageChange(1);
  }

  const prevpageClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (currentPage === 1) return;
    props.pageChange(currentPage - 1);
  }

  const nextpageClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (currentPage === pageCount) return;
    props.pageChange(currentPage + 1);
  }

  const lastpageClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (currentPage === pageCount) return;
    props.pageChange(pageCount);
  }

  return (
    <>
      {pageCount === 0 &&
        <></>}
      {pageCount > 0 &&
        <>
          <div>
            Seite {currentPage} von {pageCount}
          </div>

          <div>
            <button disabled={currentPage === 1} title='first' name="1" className="btn btn-outline-secondary" onClick={firstpageClickHandler}>
              <i title="First" style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-rewind"></i>
            </button>
            <button disabled={currentPage === 1} title='previous' name="1" className="btn btn-outline-secondary" onClick={prevpageClickHandler}>
              <i title="Previous" style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-caret-left"></i>
            </button>
            <button disabled={currentPage === pageCount} title='next' name="2" className="btn btn-outline-secondary" onClick={nextpageClickHandler}>
              <i title="Next" style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-caret-right"></i>
            </button>
            <button disabled={currentPage === pageCount} title='last' name="2" className="btn btn-outline-secondary" onClick={lastpageClickHandler}>
              <i title="Last" style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-fast-forward"></i>
            </button>
          </div>
        </>}
    </>
  );

}

export default PaginatorComponent;